/* eslint-disable */
export default {
  flipHeader: 'Käännä puhelu kohteeseen...',
  flip: 'Käännä',
  complete: 'Viimeistele kääntö',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
